var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRoundCheckBox = function SvgRoundCheckBox(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18704_242069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3024 6.65334C11.5625 6.39284 11.5621 5.97084 11.3016 5.71077C11.0411 5.4507 10.6191 5.45106 10.3591 5.71156L7.4319 8.64359L6.20436 7.41605C5.94408 7.15576 5.52207 7.15576 5.26179 7.41605C5.00151 7.67633 5.00151 8.09834 5.26179 8.35862L6.96101 10.0578C7.08607 10.1829 7.25571 10.2531 7.43257 10.2531C7.60944 10.253 7.77902 10.1826 7.90397 10.0574L11.3024 6.65334Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99918 0.666992C3.94919 0.666992 0.666016 3.95016 0.666016 8.00016C0.666016 12.0502 3.94919 15.3333 7.99918 15.3333C12.0492 15.3333 15.3323 12.0502 15.3323 8.00016C15.3323 3.95016 12.0492 0.666992 7.99918 0.666992ZM1.99902 8.00016C1.99902 4.68636 4.68538 1.99999 7.99918 1.99999C11.313 1.99999 13.9993 4.68636 13.9993 8.00016C13.9993 11.314 11.313 14.0003 7.99918 14.0003C4.68538 14.0003 1.99902 11.314 1.99902 8.00016Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18704_242069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRoundCheckBox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "roundCheckBox.9c76231432d19fdce2d3ab30f46577b4.svg";